var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-5.use[1]!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-5.use[2]!../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-5.use[3]!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register-tips.vue?vue&type=style&index=1&id=8924f710&prod&lang=scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};